<!-- Professional Privacy Policy Page -->
<div class="legal-page">
  <!-- Header -->
  <header class="legal-header">
    <div class="header-content">
      <div class="logo-section">
        <div class="logo-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
        </div>
        <div class="logo-text">
          <span class="logo-title">Sofy</span>
          <span class="logo-subtitle">Politique de confidentialité</span>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <main class="legal-content">
    <div class="content-wrapper">
      <!-- Content from backend -->
      <div class="document-content" [innerHtml]="privacyText"></div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="legal-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <strong>Logiciels INFO-DATA inc.</strong>
        <span>494 du Commodore, Lévis, QC, G7A 4Y8</span>
      </div>
      <div class="footer-copyright">
        &copy; {{ currentYear }} Logiciels INFO-DATA inc. Tous droits réservés.
      </div>
    </div>
  </footer>
</div>
